import { Event } from "../../api.types";
import { useDateFormat } from "../../hooks/useDateFormat";
import { EventStatus } from "../EventView";

export function Deadline(props: { event: Event }): (JSX.Element | null) {
    const event = props.event;
    const formatDate = useDateFormat()
    if ((event.status === EventStatus.PropositionsWait || event.status === EventStatus.Propositions) && event.propositionsDeadline) {
        return (<h3>Czas do: {formatDate(event.propositionsDeadline)}</h3>)
    } else if ((event.status === EventStatus.PreferencesWait || event.status === EventStatus.Preferences) && event.preferencesDeadline) {
        return (<h3>Czas do: {formatDate(event.preferencesDeadline)}</h3>)
    }

    return null
}
